import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth } from "../../blocks/layout/columnSpans";

/** The sitemap's one field. The designer itself is the definition's `body`. */
export const sitemapPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "sitemap",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: fullWidth,
          blocks: [
            {
              kind: "section",
              id: "section-sitemap",
              title: "",
              fields: [
                {
                  id: "field-sitemap",
                  type: "component",
                  name: "sitemap",
                  label: "",
                  componentKey: "sitemapDesigner",
                  validatorKey: "sitemap",
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
